<template>
  <div class="create-room">
    <div class="list" v-show="isCreat">
      <div class="msg-template" v-for="(data,index) in datas" :key="index">
        <img :src="data.images|filterB" alt />
        <p>{{data.Title}}</p>
        <div>
          <p>{{data.time | times}}</p>
          <button @click="goDetail(data)">查看详情</button>
        </div>
      </div>
    </div>
    <div class="detail" v-show="!isCreat">
      <div class="msg-box">
        <h2>{{detail.Title}}</h2>
        <p>
          活动时间:
          <span>{{detail.time | times}}</span>
        </p>
        <p>
          活动地点:
          <span>{{detail.place}}</span>
        </p>
        <p>
          活动类型:
          <span>{{detail.type}}</span>
        </p>
        <p>
          活动内容:
          <span>{{detail.theme}}</span>
        </p>
        <p v-show="detail.Room_id==null?false:true">
          房间ID:
          <span>{{detail.Room_id}}</span>
        </p>
      </div>
      <div class="sumbit">
        <button @click="create" v-show="detail.Room_id==null?true:false">创建房间号</button>
      </div>
    </div>
    <div class="motai" v-show="isMotai">
      <div class="msg">
        <img src="@/assets/person/pop.png" alt />
        <div class="_input">
          <el-input placeholder="请输入六位数房间号" v-model="cheakNum" clearable maxlength="6"></el-input>
        </div>
        <button @click="finterface">确认</button>
        <i class="el-icon-circle-close" @click="isMotai=false"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      isCreat: true,
      isMotai: false,
      detail: {},
      roomNum: ""
    };
  },
  computed: {
    cheakNum: {
      get: function() {
        return this.roomNum.replace(/ /g, "");
      },
      set: function(newVal) {
        if (!isNaN(newVal * 1)) return (this.roomNum = newVal);
      }
    }
  },
  methods: {
    getMsg() {
      this.axios
        .get(
          `/api/Index/GetActivity?branchID=${sessionStorage.getItem(
            "pmbid"
          )}&stateid=-1&userid=${sessionStorage.getItem('id')}`
        )
        .then(e => {
          if (e.data.code == 0) {
            this.datas = e.data.msg;
          }
        });
    },
    goDetail(data) {
      this.isCreat = false;
      this.detail = data;
      console.log(data);
    },
    create() {
      this.isMotai = true;
    },
    finterface() {
      if (this.roomNum.length != 6) alert("请输入六位数房间号");
      else {
        this.axios
          .post("/api/Index/PutRoom", {
            id: this.detail.ID,
            Room_id: this.roomNum
          })
          .then(e => {
            if (e.data.code == 0) {
              alert("创建成功");
              window.location.reload();
            } else alert(e.data.msg);
          });
      }
    }
  },
  mounted() {
    this.getMsg();
  },
  filters: {
    filterB: function(value) {
      if (value != "" && value != undefined) {
        return value.indexOf("http") > -1
          ? value
          : `http://dpinterface.djplus.cn/Partyimg/${value}`;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.create-room {
  .motai {
    .msg {
      i {
        position: absolute;
        font-size: 0.5rem;
        color: #fff;
        bottom: -0.5rem;
        left: 45%;
      }
      ._input {
        position: absolute;
        width: 80%;
        bottom: 2.5rem;
        left: 10%;
      }
      button {
        padding: 0.2rem 0.8rem;
        min-width: 40%;
        border: 0;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        color: #fff;
        border-radius: 0.34rem;
        position: absolute;
        bottom: 0.5rem;
        left: 30%;
      }
      img {
        width: 100%;
      }
      width: 80%;
      position: fixed;
      top: 20vh;
      left: 10%;
    }
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.3);
    top: 0;
  }
  .detail {
    .sumbit {
      button {
        width: 80%;
        border: 0;
        color: #fff;
        border-radius: 0.16rem;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        height: 0.8rem;
      }
      text-align: center;
      position: fixed;
      bottom: 1rem;
      width: 95%;
    }

    .msg-box {
      h2 {
        line-height: 2;
        border-bottom: 0.01rem solid #eeeeee;
      }
      p {
        span {
          margin-left: 0.2rem;
          word-break: break-all;
          color: #000;
          font-weight: normal;
        }
        color: red;
        line-height: 2;
      }
      width: 90%;
      margin: 0 auto;
    }

    border-top: 0.15rem solid #f9b94d;
    width: 94%;
    margin: 0 auto;
    border-top-left-radius: 0.08rem;
    border-top-right-radius: 0.08rem;
    background: #fff;
    min-height: 91vh;
  }
  .msg-template {
    div {
      p {
        display: inline-block;
        color: #999999;
        width: 68%;
      }
      button {
        border-radius: 0.16rem 0.16rem 0.16rem 0.06rem;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        padding: 0.1rem 0.2rem;
        color: #fff;
        border: none;
      }
      border-top: 0.01rem solid #e6e6e6;
      grid-column-start: 2;
      grid-column-end: 4;
      grid-row-start: 2;
      grid-row-end: 2;
      line-height: 2;
      padding-top: 0.2rem;
    }
    p {
      &:nth-child(2) {
        grid-column-start: 2;
        grid-column-end: 4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    img {
      width: 1.8rem;
      height: 1.8rem;
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 1;
      grid-row-end: 3;
    }
    button {
      grid-column-start: 3;
      grid-column-end: 3;
      grid-row-start: 2;
      grid-row-end: 2;
    }
    display: grid;
    grid-template-columns: 1.8rem 1fr 1fr;
    align-items: center;
    grid-gap: 0.2rem;
    background: #fff;
    width: 94%;
    margin: 0 auto 0.2rem auto;
    padding: 0.2rem;
    border-radius: 0.08rem;
  }
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>